
import { EditorConfig } from '@ckeditor/ckeditor5-core';
import { GeneralHtmlSupportConfig } from '@ckeditor/ckeditor5-html-support';
import Editor from 'ckeditor5-custom-build';

export class MessageCKEditor extends Editor {
	static defaultConfig: EditorConfig & {htmlSupport: GeneralHtmlSupportConfig}
}


MessageCKEditor.defaultConfig = {
	htmlSupport: {
		allow: [
			{
				name: /.*/,
				attributes: true,
				classes: true,
				styles: true
			}
		],
		disallow: [
			{
				name: /script|iframe/
			}
		]
	},
	toolbar: {
		items: [
			'heading',
			'fontColor',
			'fontSize',
			'|',
			'bold',
			'italic',
			'link',
			'bulletedList',
			'numberedList',
			'superscript',
			'subscript',
			'underline',
			'strikethrough',
			'removeFormat',
			'|',
			'outdent',
			'indent',
			'|',
			'codeBlock',
			'alignment',
			//'imageUpload',
			'insertImage',
			'resizeImage',
			'blockQuote',
			'insertTable',
			'mediaEmbed',
			'undo',
			'redo',
			'sourceEditing',
		]
	},
	language: 'fr',
	image: {
		toolbar: [
			'imageTextAlternative',
			'toggleImageCaption',
			'imageStyle:inline',
			'imageStyle:block',
			'imageStyle:side',
		]
	},
	/*
	table: {
		contentToolbar: [
			'tableColumn',
			'tableRow',
			'mergeTableCells'
		]
	}*/
};